export default "__VITE_ASSET__DbmvL7c8__"